<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main" style="background-color: #fff; padding: 120px 0;">
					<div class="search_logo">
						<!-- <el-image :src="require('../assets/images/searchlogo.png')" fit="contain" style="width: 200px;"></el-image> -->
						<el-image :src="detail_logo.icon" :title="detail_logo.title" style="height: 97px; cursor: pointer;" @click="toUrl('/')" fit="contain">
							<div slot="error" class="image-slot">
							</div>
						</el-image>
					</div>
					<div class="search_text">
						<el-input prefix-icon="el-icon-search" 
						placeholder="输入关键词进行搜索..." 
						v-model="keyword"
						:clearable="true"
						@clear="clearInput"
						style="width: 60%;"></el-input>
						
						<el-dropdown @command="selectSearchType">
						  <el-button plain>
						    {{search_type}}<i class="el-icon-arrow-down el-icon--right"></i>
						  </el-button>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item v-for="(item, index) in list_search_type" :key="index" :command="item.val">{{item.text}}</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
						
						<el-button type="primary" size="medium" @click="doSearch">强企搜搜</el-button>
					</div>
					<div class="search_link">
						<el-link type="primary" @click="toUrl('/')" :underline="false">强企宝典</el-link>
					</div>
					<div class="search_keyword">
						<!-- 推荐关键词： -->
						<span v-for="(item, index) in list_keyword" @click="toUrl(item.url)">{{item.title}}</span>
					</div>
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
		},
		data() {
			return {
				detail_logo: {'title': '', 'icon': '', 'summary': ''},
				list_keyword: [],
				
				keyword: '',
				
				search_type: '企业搜索',
				list_search_type: [
					{val:0, text: '企业搜索'}, 
					{val:1, text: '招股书全文检索'},
					{val:2, text: '问询答复全文检索'},
					{val:31, text: '工作导航库'}, 
					{val:33, text: '企业工具库'}, 
					{val:35, text: '企业案例库'}, 
					{val:41, text: '知识产权导航'}, 
					{val:43, text: '知识产权工具'}, 
					{val:45, text: '知识产权案例'}, 
					{val:61, text: '风险管控理论'}, 
					{val:63, text: '风险管控工具'}, 
					{val:65, text: '风险管控案例'}, 
				],
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadMenu('10088', 'detail_logo')
			this.loadMenu('10087', 'list_keyword')
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			// 点击搜索按钮
			doSearch() {
				// console.log('keyword:' , this.keyword, 'search_type:', this.search_type)
				if (this.keyword.length > 0) {
					if (this.search_type == '企业搜索') {
						let url = '/list_biaogan?trigger=sch&kw='+this.keyword+'&st=0'
						this.$router.push({path: url})
					} else if (this.search_type == '招股书全文检索') {
						let url = '/list_biaogan?trigger=sch&kw='+this.keyword+'&st=1'
						this.$router.push({path: url})
					} else if (this.search_type == '问询答复全文检索') {
						let url = '/list_wenda?trigger=sch&kw='+this.keyword+'&st=1'
						this.$router.push({path: url})
					} else if (this.search_type == '工作导航库') {
						let url = '/list_daohang?t=31&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '企业工具库') {
						let url = '/list_daohang?t=33&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '企业案例库') {
						let url = '/list_daohang?t=35&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '知识产权导航') {
						let url = '/list_zhichan?t=41&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '知识产权工具') {
						let url = '/list_zhichan?t=43&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '知识产权案例') {
						let url = '/list_zhichan?t=45&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '风险管控理论') {
						let url = '/list_fengxian?t=61&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '风险管控工具') {
						let url = '/list_fengxian?t=63&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					} else if (this.search_type == '风险管控案例') {
						let url = '/list_fengxian?t=65&trigger=sch&kw='+this.keyword
						this.$router.push({path: url})
					}
				}
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.doSearch()
				}
			},
			
			// 加载菜单下配置数据
			loadMenu(config_id, return_obj) {
				let url = this.$common.apiUrl + 'pub_web_config/detail/' + config_id
				this.$axios.get(url).then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					if (return_obj == 'detail_logo') {
						this.detail_logo = list[0]
						this.detail_logo.icon = this.$common.adimgUrl + this.detail_logo.icon
						// console.log(this.detail_logo)
					} else if (return_obj == 'list_keyword') {
						this.list_keyword = list
						console.log(this.list_keyword)
					}
				})
			},
			
			// 选择搜索类型
			selectSearchType(command) {
				// console.log(command)
				if (command == 0) {
					this.search_type = '企业搜索';
				} else if (command == 1) {
					this.search_type = '招股书全文检索';
				} else if (command == 2) {
					this.search_type = '问询答复全文检索';
				} else if (command == 31) {
					this.search_type = '工作导航库';
				} else if (command == 33) {
					this.search_type = '企业工具库';
				} else if (command == 35) {
					this.search_type = '企业案例库';
				} else if (command == 41) {
					this.search_type = '知识产权导航';
				} else if (command == 43) {
					this.search_type = '知识产权工具';
				} else if (command == 45) {
					this.search_type = '知识产权案例';
				} else if (command == 61) {
					this.search_type = '风险管控理论';
				} else if (command == 63) {
					this.search_type = '风险管控工具';
				} else if (command == 65) {
					this.search_type = '风险管控案例';
				}
			},
			
			
			
			
		}
	}
</script>

<style scoped>
</style>